export default __webpack_public_path__ + "static/media/logoCertik.5d26a253.svg";